import { useContext, useEffect } from 'react';

import { ConfigContext } from 'Context/config';
import { UserContext } from 'Context/user';

import { isOfficeHours } from 'Utilities/isOfficeHours/isOfficeHours';

import { getAgentTeamsAvailability } from 'Services/privateApi';

type AgentTeamsAvailabilityResponse = {
  data?: {
    profilingTeamAvailable?: boolean;
  };
};

const POLL_INTERVAL_MS = 60_000;

export const useAgentAvailability = () => {
  const { configActions } = useContext(ConfigContext);
  const { userState } = useContext(UserContext);

  const isLoggedIn = Number.isInteger(userState?.id);

  useEffect(() => {
    if (!isLoggedIn) {
      return undefined;
    }

    let cancelled = false;

    configActions.update({ agentAvailability: { liveChatAvailable: isOfficeHours() } });

    const fetchAvailability = () => {
      getAgentTeamsAvailability()
        .then((response: AgentTeamsAvailabilityResponse) => {
          if (cancelled) {
            return;
          }
          const available = response?.data?.profilingTeamAvailable ?? isOfficeHours();
          configActions.update({ agentAvailability: { liveChatAvailable: available } });
        })
        .catch((error: Error) => {
          if (cancelled) {
            return;
          }
          configActions.update({ agentAvailability: { liveChatAvailable: isOfficeHours() } });
          window?.Sentry?.captureException?.(error, {
            level: 'warning',
            tags: { scope: 'useAgentAvailability' },
          });
        });
    };

    fetchAvailability();
    const intervalId = setInterval(fetchAvailability, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [isLoggedIn]); // eslint-disable-line react-hooks/exhaustive-deps
};
